import { InjectionToken } from '@angular/core';

export type Locales = 'en-CA' | 'en-US' | 'fr-CA';

export interface TranslationSettingsToken {
    canToggleLanguage: boolean;
    languagesSupported: Locales[];
    defaultLanguage?: 'en-US' | 'en-CA' | 'fr-CA';
}

export const TRANSLATION_SETTINGS = new InjectionToken<TranslationSettingsToken>('translationSettings', {
    providedIn: 'root',
    factory: () => ({ canToggleLanguage: false, languagesSupported: ['en-US'], defaultLanguage: 'en-US' }),
});

export interface CountrySettingsToken {
    countryCode: 'us' | 'ca';
}

export const COUNTRY_SETTINGS = new InjectionToken<CountrySettingsToken>('countrySettings', {
    providedIn: 'root',
    factory: () => ({ countryCode: 'us' }),
});

export const REGIONS = new InjectionToken<{
    regions: Regions;
    getCodeByName: (countryCode: string, name: string) => string | null;
}>('regions', {
    providedIn: 'root',
    factory: () => {
        return {
            getCodeByName: (countryCode, name) => regions?.[countryCode.toLowerCase()]?.find((i) => i.name.toUpperCase() === name.toUpperCase())?.code,
            regions,
        };
    },
});

type Regions = {
    [countryCode: string]: { name: string; code: string }[];
};
const regions: Regions = {
    ca: [
        {
            name: 'ALBERTA',
            code: 'AB',
        },
        {
            name: 'BRITISH COLUMBIA',
            code: 'BC',
        },
        {
            name: 'MANITOBA',
            code: 'MB',
        },
        {
            name: 'NEW BRUNSWICK',
            code: 'NB',
        },
        {
            name: 'NEWFOUNDLAND & LABRADOR',
            code: 'NL',
        },
        {
            name: 'NORTHWEST TERRITORIES',
            code: 'NT',
        },
        {
            name: 'NOVA SCOTIA',
            code: 'NS',
        },
        {
            name: 'NUNAVUT',
            code: 'NU',
        },
        {
            name: 'ONTARIO',
            code: 'ON',
        },
        {
            name: 'PRINCE EDWARD ISLAND',
            code: 'PE',
        },
        {
            name: 'QUEBEC',
            code: 'QC',
        },
        {
            name: 'SASKATCHEWAN',
            code: 'SK',
        },
        {
            name: 'YUKON',
            code: 'YT',
        },
    ],
};
